import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { BaseFormComponent } from 'src/app/base/components/base-form.component';
import { EventSharedService } from 'src/app/shared/services/event-shared.service';
import { ProjetoCadastro } from '../../models/projeto-cadastro.model';
import { ProjetoCadastroService } from '../../services/projeto-cadastro.service';
import { PesquisaGeralService } from '../../services/pesquisa-geral.service';

@Component({
  selector: 'app-clonar-modal',
  templateUrl: './clonar-modal.component.html',
  styleUrls: ['./clonar-modal.component.scss']
})
export class ClonarModalComponent extends BaseFormComponent<ProjetoCadastro> implements OnInit {

  cloneId: number;
  modalRef?: BsModalRef;
  form: FormGroup;
  listProjeto: ProjetoCadastro[];
  idProjeto: number;
  infoProjeto: ProjetoCadastro;
  routerClone: any;
  paramsRouter: any;

  @ViewChild('modal') modal: TemplateRef<any>;

  constructor(
    public activatedRoute: ActivatedRoute,
    private router: Router,
    private myService: ProjetoCadastroService,
    private modalService: BsModalService,
    private pesquisaGeralService: PesquisaGeralService,
  ) {
    super(activatedRoute)
  }

  ngOnInit(): void {
    this.addSub(
      this.myService.listSimplesProjeto().subscribe({
        next: (res) => {
          this.listProjeto = res;
          this.loaded();
        },
      })
    )

    this.pesquisaGeralService.info.subscribe(info => {
      this.infoProjeto = info;
      this.idProjeto = this.infoProjeto.id;
    });
  }

  initForm() {
    this.form = new FormGroup({
      pf_id: new FormControl(this.idProjeto, Validators.required),
      param: new FormControl(null),
    });
  }

  openModal(id, router, param = false) {
    this.cloneId = id;
    this.routerClone = router;
    this.paramsRouter = param;
    this.initForm();
    this.modalRef = this.modalService.show(this.modal);
  }

  closeModal() {
    this.modalRef?.hide();
    this.form.reset();
  }

  clonar() {
    if (this.form.valid) {
      let projetoId = this.form.value.pf_id;

      //Caso seja clone de indicadores
      if (this.paramsRouter && this.routerClone == 'indicadores') {
        this.paramsRouter = {
          chkCopyAcPrtActionIndicator: this.form.value.param,
        }
      }

      this.router.navigate(['projetos', 'projeto', projetoId, this.routerClone, this.cloneId, 'clonar'], { queryParams: this.paramsRouter });
      this.closeModal();
      EventSharedService.get('loading').emit();
    }
    else {
      this.markAsDirty();
    }
  }

}
